import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormularioRespostasModal } from "@components/Modals/Shared/FormularioRespostasModal/Index";
import { makeSelectFormularioModeloByItemId } from "@store/selectors/formularios/ItemProcesso/formularioAssociadoItemProcessoSelector";
import { makeSelectFormularioRespostaByItemId } from "@store/selectors/formularios/ItemProcesso/formularioRespostaItemProcessoSelector";
import { selectStatusById } from "@store/selectors/solicitacaoSelector";
import { carregarFormularioRespostaItemProcesso } from "@store/slices/formularios/ItemProcesso/formularioRespostaItemProcessoSlice";
import CustomAntdModal from "@components/Modals/Shared/CustomAntdModal/Index";
import { DeleteFormulario } from '@services/Formulario/Index';
import { limparFormularioAssociadoItemProcesso } from '@store/slices/formularios/ItemProcesso/formularioAssociadoItemProcessoSlice';
import SweetAlert from "@components/Feedback/SweetAlert/Index";
import ButtonComp from "@components/UI/Button/Index";
import { FormularioSelectorItemProcessoModal } from "../FormularioSelectorItemProcessoModal/Index";

export const FormularioOptionItemProcessoModal = ({
    idSolicitacaoProcessoItem,
    idProcesso,
    idSolicitacao,
    formularioRespostaInicial,
}) => {
    const dispatch = useDispatch();

    // Selectors específicos de item
    const formularioModelo = useSelector(
        makeSelectFormularioModeloByItemId(idSolicitacaoProcessoItem)
    );

    const idFormularioAssociado = formularioModelo?.id;

    const formularioResposta = useSelector(
        makeSelectFormularioRespostaByItemId(idSolicitacaoProcessoItem)
    );

    const statusSolicitacao = useSelector(selectStatusById(idSolicitacao));

    const [selectorVisible, setSelectorVisible] = useState(false);
    const [respostasVisible, setRespostasVisible] = useState(false);
    const [optionsModalOpen, setOptionsModalOpen] = useState(false);
    const [modalConfig, setModalConfig] = useState({ title: '', description: '', buttons: [] });

    useEffect(() => {
        if (!formularioResposta && formularioRespostaInicial) {
            dispatch(
                carregarFormularioRespostaItemProcesso({
                    idProcessoItem: idSolicitacaoProcessoItem,
                    resposta: formularioRespostaInicial
                })
            );
        }
    }, [formularioResposta, formularioRespostaInicial, idSolicitacaoProcessoItem, dispatch]);

    const hasFormulario = Boolean(idFormularioAssociado);

    const formularioJaRespondido = Boolean(formularioResposta?.respostaJson);

    const handleClick = () => {
        // Cada case ajusta título, descrição e botões (com ButtonComp)
        if (statusSolicitacao === 1 && !hasFormulario) {
            setModalConfig({
                title: "Formulários",
                description: "Nenhum formulário associado",
                buttons: [
                    <ButtonComp
                        key="selecionar"
                        title="Selecionar um Formulário Modelo"
                        buttonColor="#125578"
                        style={{ width: '100%' }}
                        classnameIcon="fa-solid fa-list"
                        type="button"
                        hoverMessage="Selecionar formulário modelo"
                        onClick={() => {
                            setSelectorVisible(true);
                            setOptionsModalOpen(false);
                        }}
                    />,
                    <ButtonComp
                        key="cancel"
                        title="Cancelar"
                        buttonColor="#dc3545"
                        style={{ width: '100%' }}
                        classnameIcon="fa-solid fa-xmark"
                        type="button"
                        hoverMessage="Cancelar"
                        onClick={() => setOptionsModalOpen(false)}
                    />
                ]
            });
            setOptionsModalOpen(true);
            return;
        }

        if (statusSolicitacao === 1 || statusSolicitacao === 2 && hasFormulario) {
            setModalConfig({
                title: "Formulários",
                description: "Formulário Associado",
                buttons: [
                    <ButtonComp
                        key="selecionar"
                        title="Gerenciar o Formulário"
                        buttonColor="#2b97be"
                        style={{ width: '100%' }}
                        classnameIcon="fa-solid fa-list"
                        type="button"
                        hoverMessage="Gerenciar o formulário associado"
                        onClick={() => {
                            setSelectorVisible(true);
                            setOptionsModalOpen(false);
                        }}
                    />,
                    <ButtonComp
                        key="remover"
                        title="Remover Formulário Associado"
                        buttonColor="#dc3545"
                        style={{ width: '100%' }}
                        classnameIcon="fa-solid fa-trash"
                        type="button"
                        hoverMessage="Remover Formulário Associado"
                        onClick={handleDeleteFormularioAssociado}
                    />,
                ]
            });
            setOptionsModalOpen(true);
            return;
        }

        if (statusSolicitacao == 2 || statusSolicitacao === 3 && hasFormulario) {
            setModalConfig({
                title: "Formulário associado",
                description: "Você pode visualizar o formulário associado",
                buttons: [
                    <ButtonComp
                        key="visualizar"
                        title="Gerenciar o Formulário"
                        buttonColor="#125578"
                        style={{ width: '100%' }}
                        classnameIcon="fa-regular fa-eye"
                        type="button"
                        hoverMessage="Visualizar formulário vinculado a este item"
                        onClick={() => {
                            setSelectorVisible(true);
                            setOptionsModalOpen(false);
                        }}
                    />,
                    <ButtonComp
                        key="cancel"
                        title="Cancelar"
                        buttonColor="#dc3545"
                        style={{ width: '100%' }}
                        classnameIcon="fa-solid fa-xmark"
                        type="button"
                        hoverMessage="Cancelar"
                        onClick={() => setOptionsModalOpen(false)}
                    />
                ]
            });
            setOptionsModalOpen(true);
            return;
        }

        if (statusSolicitacao > 3 && formularioJaRespondido) {
            setModalConfig({
                title: "Formulário respondido",
                description: "Você pode visualizar as respostas enviadas",
                buttons: [
                    <ButtonComp
                        key="respostas"
                        title="Visualizar Respostas"
                        buttonColor="#125578"
                        style={{ width: '100%' }}
                        classnameIcon="fa-regular fa-file-lines"
                        type="button"
                        //hoverMessage="Visualizar respostas"
                        onClick={() => {
                            setRespostasVisible(true);
                            setOptionsModalOpen(false);
                        }}
                    />,
                    <ButtonComp
                        key="cancel"
                        title="Cancelar"
                        buttonColor="#dc3545"
                        style={{ width: '100%' }}
                        classnameIcon="fa-solid fa-xmark"
                        type="button"
                        //hoverMessage="Cancelar"
                        onClick={() => setOptionsModalOpen(false)}
                    />
                ]
            });
            setOptionsModalOpen(true);
            return;
        }

        // Caso padrão: apenas info
        setModalConfig({
            title: "Nenhuma ação disponível",
            description: "Nenhuma ação disponível para o estado atual.",
            buttons: [
                <ButtonComp
                    key="close"
                    title="Fechar"
                    buttonColor="#d33"
                    classnameIcon="fa-solid fa-xmark"
                    type="button"
                    hoverMessage="Fechar"
                    onClick={() => setOptionsModalOpen(false)}
                />
            ]
        });
        setOptionsModalOpen(true);
    };

    const getTooltipText = () => {
        if (formularioJaRespondido && hasFormulario) return "Formulário associado e respondido";
        if (formularioJaRespondido) return "Formulário já respondido";
        if (hasFormulario) return "Formulário associado";
        return "Nenhum formulário associado";
    };

    const handleDeleteFormularioAssociado = async () => {
        try {
            const confirmed = await SweetAlert.warning(
                'Confirma remoção do formulário associado?',
                'Esta ação removerá a associação permanentemente.'
            );
            if (!confirmed) return;
            await DeleteFormulario(idFormularioAssociado);

            dispatch(limparFormularioAssociadoItemProcesso(idSolicitacaoProcessoItem));
            
            SweetAlert.toastSuccess('Associação de formulário removida');
        } catch (error) {
            SweetAlert.error('Erro ao remover formulário', error.message);
        } finally {
            setOptionsModalOpen(false);
        }
    };

    return (
        <div>
            <div className="d-flex justify-content-center gap-2">
                <i
                    className="fa-solid fa-edit fs-6"
                    style={{ color: '#2b97be', cursor: 'pointer' }}
                    title="Opções de formulário"
                    onClick={handleClick}
                />

                <i
                    className={`fa-solid ${hasFormulario || formularioJaRespondido ? 'fa-check text-success' : 'fa-minus text-muted'} fs-6`}
                    style={{ opacity: 0.7 }}
                    title={getTooltipText()}
                />

            </div>

            <CustomAntdModal
                open={optionsModalOpen}
                onCancel={() => setOptionsModalOpen(false)}
                title={modalConfig.title}
                description={modalConfig.description}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {modalConfig.buttons}
                </div>
            </CustomAntdModal>

            <FormularioSelectorItemProcessoModal
                visible={selectorVisible}
                onClose={() => setSelectorVisible(false)}
                idSolicitacaoProcessoItem={idSolicitacaoProcessoItem}
                idProcesso={idProcesso}
                idFormularioAssociado={idFormularioAssociado}
                statusSolicitacao={statusSolicitacao}
            />

            <FormularioRespostasModal
                visible={respostasVisible}
                onClose={() => setRespostasVisible(false)}
                formularioId={formularioResposta?.id}
                idSolicitacao={idSolicitacao}
            />
        </div>
    );
};
